import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const loadAlbums = () => {
    return (dispatch) => {
	return customRequest(actions.albums.index, {}).then((res) => {
	    return dispatch({ type: actions.albums.index.status.success, data: res});
	})
    }
}

export const loadAlbum = (id) => {
    return (dispatch) => {
	dispatch({ type: actions.albums.show.status.request, data: null});
	return customRequest(actions.albums.show, {id: id}).then((res) => {
	    return dispatch({ type: actions.albums.show.status.success, data: res});
	})
    }
}
export const clearAlbum = () => {
    return (dispatch) => {
	dispatch({ type: actions.albums.show.status.request, data: null});
    }
}


export const saveAlbum = (data) => {
    return (dispatch) => {	   
	return customRequest(actions.albums.create, {album: data})
    }
}

export const updateAlbum = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.albums.update, {id: data.id, album: data})
    }
}

export const removeAlbum = (id) => {
    return (dispatch) => {		   
	return customRequest(actions.albums.delete,  {id: id})
    }
}
export const removePhoto = (id) => {
    return (dispatch) => {		   
	return customRequest(actions.photos.delete,  {id: id})
    }
}




// WEBPACK FOOTER //
// ./src/actions/Albums.js